// Educabolivia/src/components/Carousel.js
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    fade: true
  };

  const slides = [
    {
      id: 1,
      title: "Transforma tu Carrera",
      subtitle: "Cursos profesionales para tu desarrollo",
      image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80",
      buttonText: "Explorar Cursos"
    },
    {
      id: 2,
      title: "Aprende de Expertos",
      subtitle: "Instructores con experiencia internacional",
      image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80",
      buttonText: "Conoce a los Instructores"
    },
    {
      id: 3,
      title: "Certificaciones Reconocidas",
      subtitle: "Mejora tu perfil profesional",
      image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      buttonText: "Ver Certificaciones"
    }
  ];

  return (
    <div className="relative w-full h-[70vh] overflow-hidden">
      {/* Efecto diagonal */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/30 via-transparent to-transparent z-10"></div>
      
      <Slider {...settings} className="h-full">
        {slides.map((slide) => (
          <div key={slide.id} className="relative h-[70vh]">
            {/* Imagen de fondo */}
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${slide.image})` }}
            ></div>
            
            {/* Contenido */}
            <div className="relative z-20 h-full flex items-center">
              <div className="container mx-auto px-8 text-white">
                <div className="max-w-2xl ml-0 md:ml-20 transform -skew-x-6 bg-black/50 p-8 md:p-12 backdrop-blur-sm">
                  <h2 className="text-4xl md:text-6xl font-bold mb-4 skew-x-6">
                    {slide.title}
                  </h2>
                  <p className="text-xl md:text-2xl mb-8 skew-x-6">
                    {slide.subtitle}
                  </p>
                  <button className="px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded skew-x-6 transform hover:skew-x-12 transition-all duration-300">
                    {slide.buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;